import Trigger from "./Trigger"

export default class TriggerTableLine{
  vlv = false;  vlt = false;  vfr = false;  vmd = false;  vmt = false;  alt = false;  ald = false;  ats = false;  adi = false;  atm = false; amh = false; rfg = false; rfi = false; rsg = false; vmh = false; vmw = false;
  wasEdited = false;

  constructor(trigger = new Trigger, key){
    this.key = key ? key : `${trigger.indicatorId}-${trigger.unitId}-${trigger.system}-${trigger.processId}-${trigger.productId}-${trigger.equipmentId}`
    this.indicator = trigger.indicatorName ? trigger.indicatorName : "";
    this.process = trigger.process ? trigger.process : "";
    this.product = trigger.product ? trigger.product : "";
    this.equipment = trigger.equipment ? trigger.equipment : "";
    this.vlv = trigger.active && trigger.triggercode == 'VLV' ? (trigger.active ? true : false) : this.vlv;
    this.vlt = trigger.active && trigger.triggercode == 'VLT' ? (trigger.active ? true : false) : this.vlt;
    this.vfr = trigger.active && (trigger.triggercode == 'VFR' || trigger.triggercode == 'VFR_RTA') ? (trigger.active ? true : false) : this.vfr;
    this.vmd = trigger.active && (trigger.triggercode == 'VMD' || trigger.triggercode == 'VMD_RTA') ? (trigger.active ? true : false) : this.vmd;
    this.vmt = trigger.active && trigger.triggercode == 'VMT' ? (trigger.active ? true : false) : this.vmt;
    this.alt = trigger.active && trigger.triggercode == 'ALT' ? (trigger.active ? true : false) : this.alt;
    this.ald = trigger.active && (trigger.triggercode == 'ALD' || trigger.triggercode == 'ALD_RTA') ? (trigger.active ? true : false) : this.ald;
    this.ats = trigger.active && trigger.triggercode == 'ATS' ? (trigger.active ? true : false) : this.ats;
    this.adi = trigger.active && (trigger.triggercode == 'ADI' || trigger.triggercode == 'ADI_RTA') ? (trigger.active ? true : false) : this.adi;
    this.atm = trigger.active && trigger.triggercode == 'ATM' ? (trigger.active ? true : false) : this.atm;
    this.amh = trigger.active && trigger.triggercode == 'AMH' ? (trigger.active ? true : false) : this.amh;

    this.rfg = trigger.active && trigger.triggercode == 'RFG' ? (trigger.active ? true : false) : this.rfg;
    this.rfi = trigger.active && trigger.triggercode == 'RFI' ? (trigger.active ? true : false) : this.rfi;
    this.rsg = trigger.active && trigger.triggercode == 'RSG' ? (trigger.active ? true : false) : this.rsg;
    
    this.vmh = trigger.active && trigger.triggercode == 'VMH' ? (trigger.active ? true : false) : this.vmh;
    this.vmw = trigger.active && trigger.triggercode == 'VMW' ? (trigger.active ? true : false) : this.vmw;
  }

  setTriggerOnOff(trigger){
    this.vlv = trigger.vlv ? true : this.vlv;
    this.vlt = trigger.vlt ? true : this.vlt;
    this.vfr = trigger.vfr ? true : this.vfr;
    this.vmd = trigger.vmd ? true : this.vmd;
    this.vmt = trigger.vmt ? true : this.vmt;
    this.alt = trigger.alt ? true : this.alt;
    this.ald = trigger.ald ? true : this.ald;
    this.ats = trigger.ats ? true : this.ats;
    this.adi = trigger.adi ? true : this.adi;
    this.atm = trigger.atm ? true : this.atm;
    this.amh = trigger.amh ? true : this.amh;

    this.rfg = trigger.rfg ? true : this.rfg;
    this.rfi = trigger.rfi ? true : this.rfi;
    this.rsg = trigger.rsg ? true : this.rsg;
    this.vmh = trigger.vmh ? true : this.vmh;
    this.vmw = trigger.vmw ? true : this.vmw;
  }
}